import { Factory } from 'miragejs';

import { QONTO_LOGO_64 } from '@qonto/mirage/constants/organization';

export default Factory.extend({
  name: i => `Client ${i + 1}`,
  logoUri: QONTO_LOGO_64,
});
